import { Autocomplete, Button, Grid, Tab, Tabs, TextField, Typography, Backdrop, CircularProgress, FormGroup, FormControlLabel, Switch, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import RequestStatusAlert from '../../lib/components/RequestStatusAlert';
import doRequest from '../../lib/services/apiRequestor';
import FilterParameter from '../../lib/components/FilterParameter';
import NewFilterParameter from '../../lib/components/NewFilterParameter';
import OrderByFilter from '../../lib/components/OrderByFilter';
import { v4 as uuidv4 } from 'uuid';

function DataProductPanel(props) {
    const { value, index, dataProducts, idToken, reRender, setRefresh, generateKey } = props;
    const [selectedItem, setSelectedItem] = useState(null);
    const [deletedInput, setDeletedInput] = useState([]);

    // Helper function to convert boolean/string to boolean
    const toBool = (value) => {
      if (typeof value === 'boolean') return value;
      if (typeof value === 'string') return value.toLowerCase() === 'true';
      return false;
    };
    const [newFilter, setNewFilter] = useState(0);
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [newIds, setNewIds] = useState([]);
    const [isDataProductEnabled, setIsDataProductEnabled] = useState(false);
    const [isDataDownloadEnabled, setIsDataDownloadEnabled] = useState(false);
    const [isApiEnabled, setIsApiEnabled] = useState(false);
    const [isMarketPlaceEnabled, setIsMarketPlaceEnabled] = useState(false);
    const [isDataPreviewEnabled, setIsDataPreviewEnabled] = useState(false);
    const [sampleSQLQuery, setSampleSQLQuery] = useState('');
    const [dataAccessUrl, setDataAccessUrl] = useState('');
    const [dataQualityStatement, setDataQualityStatement] = useState('');
    const [reports, setReports] = useState([]);
    const [externalContents, setExternalContents] = useState([]);
    const [selectedRelatedContent, setSelectedRelatedContent] = useState(null);
    const [isCreatingNew, setIsCreatingNew] = useState(false);
    const [newProductName, setNewProductName] = useState('');
    const [snowflakeDataSources, setSnowflakeDataSources] = useState([]);
    const [selectedSnowflakeDataSourceId, setSelectedSnowflakeDataSourceId] = useState('');
    const [dataProductViewName, setDataProductViewName] = useState('');
  
    var options = dataProducts?.map((item) => {
      return item.dataProductName
    });
    const loading = options.length === 0;

    useEffect(() => {
        if (value === index && idToken) {
            doRequest('/api/ExternalReports', idToken)
                .then((response) => {
                    if (!response.isError) {
                        setReports(response.data || []);
                    }
                });
            doRequest('/api/ExternalContent', idToken)
                .then((response) => {
                    if (!response.isError) {
                        setExternalContents(response.data || []);
                    }
                });
            doRequest('/api/SnowflakeDataSources', idToken)
                .then((response) => {
                    if (!response.isError) {
                        setSnowflakeDataSources(response.data || []);
                    }
                });
        }
    }, [value, idToken]);
  
    const handleCreateNew = () => {
      setIsCreatingNew(true);
      setSelectedItem(null);
      setNewProductName('');
      setDeletedInput([]);
      setStatusMessage(null);
      setSeverity(null);
      setNewFilter(0);
      setIsDataProductEnabled(false);
      setIsDataDownloadEnabled(false);
      setIsApiEnabled(false);
      setIsMarketPlaceEnabled(false);
      setIsDataPreviewEnabled(false);
      setSampleSQLQuery('');
      setDataAccessUrl('');
      setDataQualityStatement('');
      setSelectedSnowflakeDataSourceId('');
      setDataProductViewName('');
    }

    const handleChange = (newValue) => {
      if (!newValue) return
      
      setIsCreatingNew(false);
      
      var selected = dataProducts.find((item) => {
        return item.dataProductName === newValue
      });
  
      selected.columns = [];
      selected.input = { 
        headers: {
          enabled: selected.enabled,
          isDataDownloadEnabled: selected.isDataDownloadEnabled,
          isApiEnabled: selected.isApiEnabled,
          isMarketPlaceEnabled: selected.isMarketPlaceEnabled,
          isDataPreviewEnabled: selected.isDataPreviewEnabled,
          sampleSQLQuery: selected.sampleSQLQuery,
          dataAccessUrl: selected.dataAccessUrl,
          dataQualityStatement: selected.dataQualityStatement,
          reportId: selected.reportId,
          relatedContent: selected.relatedContent || [],
          snowflakeDataSourceId: selected.snowflakeDataSourceId || null,
          dataProductViewName: selected.dataProductViewName || ''
        }, 
        parameters:[]
      };
      // Initialize relatedContent if it doesn't exist
      if (!selected.relatedContent) {
        selected.relatedContent = [];
      }
      selected.appliedFilterCount = selected?.customParameters.length;
      selected?.customParameters.sort((a, b) => a.order - b.order)
      setSelectedItem(selected);
      setDeletedInput([]);
      setStatusMessage(null);
      setSeverity(null);
      setNewFilter(0);
      setIsDataProductEnabled(toBool(selected.enabled));
      setIsDataDownloadEnabled(toBool(selected.isDataDownloadEnabled));
      setIsApiEnabled(toBool(selected.isApiEnabled));
      setIsMarketPlaceEnabled(toBool(selected.isMarketPlaceEnabled));
      setIsDataPreviewEnabled(toBool(selected.isDataPreviewEnabled));
      setSampleSQLQuery(selected.sampleSQLQuery || '');
      setDataQualityStatement(selected.dataQualityStatement || '');
      setSelectedSnowflakeDataSourceId(selected.snowflakeDataSourceId || '');
      setDataProductViewName(selected.dataProductViewName || '');
      
      // Suggest DataAccessUrl if empty
      const suggestedUrl = selected.dataAccessUrl || `${window.location.origin}/explore/data-products/${encodeURIComponent(selected.dataProductName)}`;
      setDataAccessUrl(suggestedUrl);
      if (!selected.dataAccessUrl) {
        selected.input.headers.dataAccessUrl = suggestedUrl;
        selected.dataAccessUrl = suggestedUrl;
      }
  
      doRequest(`/api/Columns/?DataProductName=${selected.dataProductName}`, idToken, { method: "GET" })
      .then((response) => {
        setSelectedItem(prevState => {
          let newObj = { ...prevState}
          newObj.columns = response.data.filter(column => !selected.customParameters.map(x => x.name).includes(column));
          return newObj;
        });
      })
    }

    const handleDataProductEnabled = (event) => {
        setIsDataProductEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleDataDownloadEnabled = (event) => {
        setIsDataDownloadEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleApiEnabled = (event) => {
        setIsApiEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleMarketPlaceEnabled = (event) => {
        setIsMarketPlaceEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleDataPreviewEnabled = (event) => {
        setIsDataPreviewEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleDataProductViewNameChange = (event) => {
        const value = event.target.value;
        setDataProductViewName(value);
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, dataProductViewName: value
                    }
                }
            }
            newObj.dataProductViewName = value;
            return newObj;
        })
    }

    const handleSampleSQLQueryChange = (event) => {
        const value = event.target.value;
        setSampleSQLQuery(value);
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, sampleSQLQuery: value
                    }
                }
            }
            newObj.sampleSQLQuery = value;
            return newObj;
        })
    }

    const handleDataAccessUrlChange = (event) => {
        const value = event.target.value;
        setDataAccessUrl(value);
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, dataAccessUrl: value
                    }
                }
            }
            newObj.dataAccessUrl = value;
            return newObj;
        })
    }

    const handleDataQualityStatementChange = (event) => {
        const value = event.target.value;
        setDataQualityStatement(value);
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, dataQualityStatement: value
                    }
                }
            }
            newObj.dataQualityStatement = value;
            return newObj;
        })
    }

    const handleRelatedReportChange = (event) => {
        const value = event.target.value;
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, reportId: value
                    }
                }
            }
            newObj.reportId = value;
            return newObj;
        })
    }

    const handleSnowflakeDataSourceChange = (event) => {
        const value = event.target.value;
        setSelectedSnowflakeDataSourceId(value);
        setSelectedItem(prevState => {
            if (!prevState) return null;
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, snowflakeDataSourceId: value || null
                    }
                }
            }
            newObj.snowflakeDataSourceId = value || null;
            return newObj;
        })
    }
  
    const validate =() =>{
      let validation = true;
    
      selectedItem?.input.parameters.map((param) => {
        if(param.isValid !== undefined && !param.isValid){
          setStatusMessage(statusMessage === "Parameter Name is required."? "Can not proceed with incomplete input data." : "Parameter Name is required.")
          setSeverity("warning")
          validation = false
        }
      })
  
      return validation
    }

    const handleCreateSubmit = (event) => {
      event.preventDefault();
      
      if (!newProductName.trim()) {
        setStatusMessage("Product Name is required.")
        setSeverity("warning")
        return;
      }

      setStatusMessage(null);
      setSeverity(null);
      setIsLoading(true);

      const createInput = {
        DataProductName: newProductName.trim(),
        Enabled: isDataProductEnabled ? 'true' : 'false',
        IsApiEnabled: isApiEnabled,
        IsDataDownloadEnabled: isDataDownloadEnabled,
        IsMarketPlaceEnabled: isMarketPlaceEnabled,
        IsDataPreviewEnabled: isDataPreviewEnabled,
        DataAccessUrl: dataAccessUrl || null,
        SampleSQLQuery: sampleSQLQuery || null,
        DataQualityStatement: dataQualityStatement || null,
        SnowflakeDataSourceId: selectedSnowflakeDataSourceId || null,
        DataProductViewName: dataProductViewName || null
      };

      doRequest(`/api/DataProduct?DataProductName=${createInput.DataProductName}`, idToken, {
        method: "POST",
        body: JSON.stringify(createInput)
      })
      .then((response) => {
        if (!response.isError) {
          setStatusMessage("Data Product created successfully.")
          setSeverity("success")
          setIsCreatingNew(false);
          setNewProductName('');
          setRefresh(prevState => !prevState);
          setIsLoading(false);
        } else {
          setStatusMessage("An error occurred while creating the data product. Please retry.")
          setSeverity("error")
          setIsLoading(false);
        }
      })
    }
  
    const handleSubmit = (event, input) => {
      event.preventDefault();
      
      if(!validate()) return
  
      setStatusMessage(null);
      setSeverity(null);
      setIsLoading(true);
  
        if ((input.headers !== undefined && Object.keys(input.headers).length > 0) || input.parameters?.length > 0) {
  
        doRequest(`/api/CustomParametersPut/?DataProductName=${selectedItem.dataProductName}`, idToken, {
          method: "PUT",
          body: JSON.stringify(input)
        })
        .then((response) => {
          if (!response.isError) {
            setStatusMessage("Saved.")
            setSeverity("success")
            setNewFilter(0);
            setRefresh(prevState => !prevState);
            setIsLoading(false);
          } else {
            setStatusMessage("An error occurred, please retry.")
            setSeverity("error")
            setIsLoading(false);
          }
        })
      }
  
      if (Object.keys(deletedInput).length) {
        let objDeletedItems = [];
        deletedInput?.map((parameter) => {
          objDeletedItems.push({"name" : parameter});
        })

        doRequest(`/api/CustomParametersDelete/?DataProductName=${selectedItem.dataProductName}`, idToken, {
          method: "DELETE",
          body: JSON.stringify(objDeletedItems)
        })
        .then((response) => {
          if (!response.isError) {
            setStatusMessage("Saved.")
            setSeverity("success")
            setNewFilter(0);
            setRefresh(prevState => !prevState);
            setIsLoading(false);
          } else {
            setStatusMessage("An error occurred, please retry.")
            setSeverity("error")
            setIsLoading(false);
          }
        })
        setDeletedInput([])
      }
    }
  
    const addNewFilter = () => {
      setNewIds(inputs => [...inputs, generateKey()])
      let newFilterCount = newFilter + 1
      setNewFilter(newFilterCount)
      setSelectedItem(prevState => {
        let selected = prevState;
        selected.appliedFilterCount = selected.customParameters.length + newFilterCount;
        return selected;
      })
    }
  
    const deleteNewFilter = (filterName, id) => {
      let newFilterCount = newFilter - 1;
      setSelectedItem(prevState => {
        let newObj = prevState;
  
        //adjust order of filter ahead of this filter
        let currentparameter = newObj.input.parameters.filter((item) => item.name === filterName)
        let orderNo = currentparameter[0].order
        
        newObj.input.parameters  = newObj.input.parameters.map((param) => {
          if(param.order > orderNo){
            let newOrder = param.order;
            return {...param, order: newOrder -1}
          }
          return param;
        })
  
        newObj.input.parameters = newObj.input.parameters.filter(param => param.name !== filterName)
        newObj.appliedFilterCount = newObj.customParameters.length + newFilterCount;
  
        return newObj;
      })
  
      setNewIds(prevState => {return prevState.filter(x=> x != id)});
      setNewFilter(newFilterCount);
    }
  
    const deleteExistingFilter = (filterName) => {
      setDeletedInput(inputs => [...inputs, filterName]); 
      let updatedItems = [];
      let isOrderAdjusted = false;
      setSelectedItem(prevState => {
        let selectedItemObj = prevState;

        let currentparameter = selectedItemObj.customParameters.filter((item) => item.name === filterName)
        let orderNo = currentparameter[0]?.order
        let updatedCustomParameters = selectedItemObj.customParameters.map((item) => {
          if (item.order > orderNo) {
            return {...item, order: item.order - 1}
          }
          return item
        })
  
        updatedCustomParameters.map((item) => {
          if (item.order >= orderNo && updatedItems.filter((x) => x.name === item.name).length === 0 ) {
            updatedItems.push({name: item.name, order: item.order})
          }
        })
        selectedItemObj.customParameters = updatedCustomParameters.filter((item) => item.name !== filterName);
  
        if(!isOrderAdjusted){
          selectedItemObj.input.parameters = selectedItemObj.input.parameters.map((param) => {
            if(param.order > orderNo){
              isOrderAdjusted = true;
              return {...param, order : param.order - 1};
            }
            return param;
          })
        }
  
        updatedItems.map((item) =>{
          let isModificationConsidered = selectedItemObj.input.parameters.filter((param) => param.name === item.name)
          if(isModificationConsidered.length === 0){
            selectedItemObj.input.parameters = [...selectedItemObj.input.parameters, item]
          }
        })
  
        selectedItemObj.input.parameters = selectedItemObj.input.parameters.filter((param) => {return param.name !== filterName})
        selectedItemObj.appliedFilterCount = selectedItemObj.customParameters.length + newFilter;
        return selectedItemObj;
      });
    }
  
    useEffect(() => {
        setSelectedItem(null);
        setDeletedInput([]);
        setStatusMessage(null);
        setSeverity(null);
    }, [value])
  
    useEffect(() => {
      if (selectedItem && statusMessage) {
        handleChange(selectedItem.dataProductName)
      }
    },[reRender])

    const handleAddRelatedContent = () => {
      if (!selectedRelatedContent) return;
      
      setSelectedItem(prevState => {
        // Check if this content is already in the list
        const existingContent = prevState.relatedContent || [];
        if (existingContent.some(item => item.id === selectedRelatedContent.id)) {
          return prevState;
        }
        
        const newContent = [...existingContent, {
          id: selectedRelatedContent.id,
          displayTitle: selectedRelatedContent.displayTitle,
          contentType: selectedRelatedContent.contentType,
          contentLink: selectedRelatedContent.contentLink
        }];
        return {
          ...prevState,
          relatedContent: newContent,
          input: {
            ...prevState.input,
            headers: {
              ...prevState.input.headers,
              relatedContent: newContent
            }
          }
        };
      });
      setSelectedRelatedContent(null);
    };

    const handleRemoveRelatedContent = (indexToRemove) => {
      setSelectedItem(prevState => {
        const newContent = prevState.relatedContent.filter((_, index) => index !== indexToRemove);
        return {
          ...prevState,
          relatedContent: newContent,
          input: {
            ...prevState.input,
            headers: {
              ...prevState.input.headers,
              relatedContent: newContent
            }
          }
        };
      });
    };

    useEffect(() => {
      if (selectedItem && dataProducts.length > 0) {
        const updatedProduct = dataProducts.find(item => item.dataProductName === selectedItem.dataProductName);
        if (updatedProduct) {
          // Update the selected item with fresh data from backend
          const freshData = {
            ...selectedItem,
            enabled: updatedProduct.enabled,
            isDataDownloadEnabled: updatedProduct.isDataDownloadEnabled,
            isApiEnabled: updatedProduct.isApiEnabled,
            isMarketPlaceEnabled: updatedProduct.isMarketPlaceEnabled,
            isDataPreviewEnabled: updatedProduct.isDataPreviewEnabled,
            sampleSQLQuery: updatedProduct.sampleSQLQuery,
            dataAccessUrl: updatedProduct.dataAccessUrl,
            dataQualityStatement: updatedProduct.dataQualityStatement,
            reportId: updatedProduct.reportId,
            relatedContent: updatedProduct.relatedContent || [],
            snowflakeDataSourceId: updatedProduct.snowflakeDataSourceId || null,
            dataProductViewName: updatedProduct.dataProductViewName || '',
            input: {
              ...selectedItem.input,
              headers: {
                ...selectedItem.input.headers,
                enabled: updatedProduct.enabled,
                isDataDownloadEnabled: updatedProduct.isDataDownloadEnabled,
                isApiEnabled: updatedProduct.isApiEnabled,
                isMarketPlaceEnabled: updatedProduct.isMarketPlaceEnabled,
                isDataPreviewEnabled: updatedProduct.isDataPreviewEnabled,
                sampleSQLQuery: updatedProduct.sampleSQLQuery,
                dataAccessUrl: updatedProduct.dataAccessUrl,
                dataQualityStatement: updatedProduct.dataQualityStatement,
                reportId: updatedProduct.reportId,
                relatedContent: updatedProduct.relatedContent || [],
                snowflakeDataSourceId: updatedProduct.snowflakeDataSourceId || null,
                dataProductViewName: updatedProduct.dataProductViewName || ''
              }
            }
          };
          setSelectedItem(freshData);
          setIsDataProductEnabled(toBool(updatedProduct.enabled));
          setIsDataDownloadEnabled(toBool(updatedProduct.isDataDownloadEnabled));
          setIsApiEnabled(toBool(updatedProduct.isApiEnabled));
          setIsMarketPlaceEnabled(toBool(updatedProduct.isMarketPlaceEnabled));
          setIsDataPreviewEnabled(toBool(updatedProduct.isDataPreviewEnabled));
          setSampleSQLQuery(updatedProduct.sampleSQLQuery || '');
          setDataAccessUrl(updatedProduct.dataAccessUrl || '');
          setDataQualityStatement(updatedProduct.dataQualityStatement || '');
          setSelectedSnowflakeDataSourceId(updatedProduct.snowflakeDataSourceId || '');
          setDataProductViewName(updatedProduct.dataProductViewName || '');
        }
      }
    }, [dataProducts])
  
    return (
      <Grid container item xs={12} hidden={value !== index} spacing={1}>
        {value === index && (
          <>
            <Grid item xs={10}>
              {isCreatingNew ? (
                <TextField
                  fullWidth
                  label="New Product Name"
                  value={newProductName}
                  onChange={(e) => setNewProductName(e.target.value)}
                  required
                />
              ) : (
                <Autocomplete
                  options={options}
                  renderInput={(params) => <TextField {...params} label="Data Product" />}
                  onChange={(event, newValue) => {
                    handleChange(newValue);
                  }}
                  loading={loading}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              {isCreatingNew ? (
                <>
                  <Button variant="contained" size="large" onClick={handleCreateSubmit} sx={{ marginTop: "7px", marginRight: "5px" }}>Create</Button>
                  <Button variant="outlined" size="large" onClick={() => setIsCreatingNew(false)} sx={{ marginTop: "7px" }}>Cancel</Button>
                </>
              ) : (
                <>
                  <Button variant="contained" size="large" onClick={(event) => handleSubmit(event, selectedItem?.input)} disabled={!selectedItem} sx={{ marginTop: "7px", marginRight: "5px" }}>Save</Button>
                  <Button variant="outlined" size="large" onClick={handleCreateNew} sx={{ marginTop: "7px" }}>Create New</Button>
                </>
              )}
              <Backdrop sx={{ color: '#055A60', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            </Grid>
            <Grid item xs={12}>
              <RequestStatusAlert message={statusMessage} severity={severity} />
            </Grid>
            
            {(selectedItem || isCreatingNew) && (
              <Grid container spacing={2} style={{ width: '100%', marginTop: '5px', marginLeft: '5px' }}>
                <Grid
                    item xs={5}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={isDataProductEnabled} onChange={(event) => handleDataProductEnabled(event)} name="enabled" />}
                            label="Active"
                        />
                    </FormGroup>
                </Grid>
                <Grid
                    item xs={5}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={isDataDownloadEnabled} onChange={(event) => handleDataDownloadEnabled(event)} name="isDataDownloadEnabled" />}
                            label="Allow Data Download in UI"
                        />
                    </FormGroup>
                </Grid>
                <Grid
                    item xs={5}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={isApiEnabled} onChange={(event) => handleApiEnabled(event)} name="isApiEnabled" />}
                            label="Allow API Data Download"
                        />
                    </FormGroup>
                </Grid>
                <Grid
                    item xs={5}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={isMarketPlaceEnabled} onChange={(event) => handleMarketPlaceEnabled(event)} name="isMarketPlaceEnabled" />}
                            label="Enable in Marketplace"
                        />
                    </FormGroup>
                </Grid>
                <Grid
                    item xs={5}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={isDataPreviewEnabled} onChange={(event) => handleDataPreviewEnabled(event)} name="isDataPreviewEnabled" />}
                            label="Allow Data Preview in UI"
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    label="Related Report"
                    fullWidth
                    value={selectedItem?.reportId || ''}
                    onChange={handleRelatedReportChange}
                    name="reportId"
                  >
                    <MenuItem value="">None</MenuItem>
                    {reports.map((report) => (
                      <MenuItem key={report.id} value={report.id}>
                        {report.title} ({report.externalProviderReportId})
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    label="Snowflake Data Source"
                    fullWidth
                    value={selectedSnowflakeDataSourceId}
                    onChange={handleSnowflakeDataSourceChange}
                    name="snowflakeDataSourceId"
                    helperText="Assign a Snowflake data source to this data product"
                  >
                    <MenuItem value="">None</MenuItem>
                    {snowflakeDataSources.map((ds) => (
                      <MenuItem key={ds.id} value={ds.id}>
                        {ds.database}.{ds.schema} ({ds.warehouse})
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Data Product View Name"
                    fullWidth
                    value={dataProductViewName}
                    onChange={handleDataProductViewNameChange}
                    name="dataProductViewName"
                    helperText="The database view/table name used for querying this data product"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Sample SQL Query"
                    fullWidth
                    multiline
                    rows={4}
                    value={sampleSQLQuery}
                    onChange={handleSampleSQLQueryChange}
                    name="sampleSQLQuery"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Data Access URL"
                    fullWidth
                    value={dataAccessUrl}
                    onChange={handleDataAccessUrlChange}
                    name="dataAccessUrl"
                    placeholder="https://example.com/api/data"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Data Quality Statement"
                    fullWidth
                    multiline
                    rows={4}
                    value={dataQualityStatement}
                    onChange={handleDataQualityStatementChange}
                    name="dataQualityStatement"
                    inputProps={{ maxLength: 4000 }}
                  />
                </Grid>
                {!isCreatingNew && (
                  <>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                      <Typography variant="h6">Related Content</Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Autocomplete
                        value={selectedRelatedContent}
                        onChange={(event, newValue) => setSelectedRelatedContent(newValue)}
                        options={externalContents.filter(content => 
                          !(selectedItem?.relatedContent || []).some(item => item.id === content.id)
                        )}
                        getOptionLabel={(option) => option.displayTitle || ''}
                        renderInput={(params) => <TextField {...params} label="Select External Content" />}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Button 
                        variant="contained" 
                        onClick={handleAddRelatedContent}
                        disabled={!selectedRelatedContent}
                        sx={{ marginTop: '7px' }}
                      >
                        Add
                      </Button>
                    </Grid>
                    {selectedItem?.relatedContent && selectedItem.relatedContent.length > 0 && (
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          {selectedItem.relatedContent.map((content, index) => (
                            <Grid item xs={12} key={content.id || index}>
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={10}>
                                  <TextField
                                    fullWidth
                                    value={content.displayTitle || content.title || ''}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button 
                                    variant="outlined" 
                                    color="error"
                                    onClick={() => handleRemoveRelatedContent(index)}
                                    size="small"
                                  >
                                    Remove
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    )}
                  </>
                )}
                {!isCreatingNew && selectedItem && (
                  <>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                      <Typography variant="h6">Custom Filters</Typography>
                        </Grid>
                    <Grid item xs={12} style={{marginBottom: '10px'}}>
                      <Button variant="contained" onClick={addNewFilter}>Add Filter</Button>
                    </Grid>
                    <Grid item xs={12}>
                    <form>
                    <Grid container spacing={2} sx={{ width: '100%'}}>
                      { 
                      selectedItem?.customParameters?.map((parameter, index) => {
                          return (
                            <FilterParameter key={parameter.id} index={index} parameterName={parameter.name} selectedItem={selectedItem} setSelectedItem={setSelectedItem} deleteFilter={deleteExistingFilter} type={"dataProduct"}/>
                          )
                        })}
                      { [...Array(newFilter).keys()].map((index) => {                    
                          return (
                            <NewFilterParameter key={newIds[index]} id={newIds[index]} index={index} selectedItem={selectedItem} setSelectedItem={setSelectedItem} deleteFilter={deleteNewFilter} type={"dataProduct"}/>
                          )
                        })}
                    </Grid>
                    </form>
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </>
        )}
      </Grid>
    )
  }
  
function BespokeViewPanel(props) {
    const { children, value, index, idToken, bespokeViews, reRender, setRefresh, generateKey, ...other } = props;
    const [selectedItem, setSelectedItem] = useState(null);
    const [deletedInput, setDeletedInput] = useState([]);
    const [newFilter, setNewFilter] = useState(0);
    const [newIds, setNewIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);
    const [disableOrderBtn, setDisableOrderBtn] = useState(false);
    const [showOrderPanel, setShowOrderPanel] = useState(false);
    const [isBespokeEnabled, setIsBespokeEnabled] = useState(false);
    const [reports, setReports] = useState([]);

    var options = bespokeViews?.map((item) => {
        return item.displayName
    });
    const loading = options.length === 0;

    useEffect(() => {
        if (value === index && idToken) {
            doRequest('/api/ExternalReports', idToken)
                .then((response) => {
                    if (!response.isError) {
                        setReports(response.data || []);
                    }
                });
        }
    }, [value, idToken]);

    const handleChange = (newValue) => {
        if (!newValue) return

        var selected = bespokeViews.find((item) => {
            return item.displayName === newValue
        });

        let appliedFilterCount = selected?.customViewsParameters.length;

        selected.columns = [];
        selected.orderColumns = [];
        selected.input = { headers: {}, parameters: [] };
        selected.appliedFilterCount = appliedFilterCount;
        selected?.customViewsParameters.sort((a, b) => a.order - b.order)
        setSelectedItem(selected);
        setDeletedInput([]);
        setStatusMessage(null);
        setSeverity(null);
        setNewFilter(0);
        setDisableOrderBtn(selected.orderByColumn ? true : false);
        setShowOrderPanel(selected.orderByColumn ? true : false);
        setIsBespokeEnabled(selected.enabled.toLowerCase() === "true");

        doRequest(`/api/Columns/?CustomViewName=${selected.name}`, idToken, { method: "GET" })
            .then((response) => {
                setSelectedItem(prevState => {
                    let newObj = { ...prevState }
                    newObj.columns = response.data.filter(column => !selected.customViewsParameters.map(x => x.name).includes(column));
                    newObj.orderColumns = response.data
                    return newObj;
                });
            })
    }

    const handleBespokeEnabled = (event) => {
        setIsBespokeEnabled(event.target.checked);
        const target = event.target;
        const value = target.checked ? 'true' : 'false';
        const targetName = target.name;

        setSelectedItem(prevState => {
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleHeaderInputChange = (event) => {
        const target = event.target;
        const value = target.value;
        const targetName = target.name;

        setSelectedItem(prevState => {
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, [targetName]: value
                    }
                }
            }
            newObj[targetName] = value;
            return newObj;
        })
    }

    const handleRelatedReportChange = (event) => {
        const value = event.target.value;
        setSelectedItem(prevState => {
            let newObj = {
                ...prevState, input: {
                    ...prevState.input, headers: {
                        ...prevState.input.headers, reportId: value
                    }
                }
            }
            newObj.reportId = value;
            return newObj;
        })
    }

    const addNewFilter = () => {
        setNewIds(inputs => [...inputs, generateKey()])
        let newFilterCount = newFilter + 1;
        setNewFilter(newFilterCount)
        setSelectedItem(prevState => {
            let selected = prevState;
            selected.appliedFilterCount = selected.customViewsParameters.length + newFilterCount;
            return selected;
        })
    }

    const addNewOrder = () => {
        setShowOrderPanel(true)
        setDisableOrderBtn(true);
    }

    const deleteOrderBy = () => {
        setSelectedItem(prevState => {
            let newObj = prevState;
            newObj.orderByColumn = null;
            newObj.orderByDirection = null;
            newObj.input.headers.orderByColumn = null
            newObj.input.headers.orderByDirection = null
            return newObj;
        })
        setShowOrderPanel(false)
        setDisableOrderBtn(false);
    }

    const deleteNewFilter = (filterName, id) => {
        let newFilterCount = newFilter - 1;
        setSelectedItem(prevState => {
            let newObj = prevState;

            //adjust order of filter ahead of this filter
            let currentparameter = newObj.input.parameters.filter((item) => item.name === filterName)
            let orderNo = currentparameter[0]?.order

            newObj.input.parameters = newObj.input.parameters.map((param) => {
                if (param.order > orderNo) {
                    let newOrder = param.order;
                    return { ...param, order: newOrder - 1 }
                }
                return param;
            })

            newObj.input.parameters = newObj.input.parameters.filter(param => param.name !== filterName)
            newObj.appliedFilterCount = newObj.customViewsParameters.length + newFilterCount;

            return newObj;
        })

        setNewIds(prevState => { return prevState.filter(x => x != id) });
        setNewFilter(newFilterCount);
    }

    const deleteExistingFilter = (filterName) => {
        setDeletedInput(inputs => [...inputs, filterName]);
        let updatedItems = [];
        let isOrderAdjusted = false;
        setSelectedItem(prevState => {

            //adjust existing filters order
            let selectedItemObj = prevState;
            let currentparameter = selectedItemObj.customViewsParameters.filter((item) => item.name === filterName)
            let orderNo = currentparameter[0]?.order
            let updatedCustomViewsParameters = selectedItemObj.customViewsParameters.map((item) => {
                if (item.order > orderNo) {
                    return { ...item, order: item.order - 1 }
                }
                return item
            })

            updatedCustomViewsParameters.map((item) => {
                if (item.order >= orderNo && updatedItems.filter((x) => x.name === item.name).length === 0) {
                    updatedItems.push({ name: item.name, order: item.order })
                }
            })
            selectedItemObj.customViewsParameters = updatedCustomViewsParameters.filter((item) => item.name !== filterName);

            //adjust and update new/modified filters order
            if (!isOrderAdjusted) {
                selectedItemObj.input.parameters = selectedItemObj.input.parameters.map((param) => {
                    if (param.order > orderNo) {
                        isOrderAdjusted = true;
                        return { ...param, order: param.order - 1 };
                    }
                    return param;
                })
            }

            updatedItems.map((item) => {
                let isModificationConsidered = selectedItemObj.input.parameters.filter((param) => param.name === item.name)
                if (isModificationConsidered.length === 0) {
                    selectedItemObj.input.parameters = [...selectedItemObj.input.parameters, item]
                }
            })

            //remove modification entry
            selectedItemObj.input.parameters = selectedItemObj.input.parameters.filter((param) => { return param.name !== filterName })
            selectedItemObj.appliedFilterCount = selectedItemObj.customViewsParameters.length + newFilter;
            return selectedItemObj;
        });
    }

    const validate = () => {
        let validation = true

        if (selectedItem?.input.parameters.length === 0 &&
            (selectedItem?.input.headers === undefined || Object.keys(selectedItem?.input.headers).length === 0) &&
            Object.keys(deletedInput).length === 0) return;

        selectedItem?.input.parameters.map((param) => {
            if (param.isValid !== undefined && !param.isValid) {
                setStatusMessage(statusMessage === "Parameter Name is required." ? "Can not proceed with in complete input data." : "Parameter Name is required.")
                setSeverity("warning")
                return validation = false
            }
        })

        if(showOrderPanel){
            if (selectedItem?.input.headers.hasOwnProperty('orderByColumn') && (selectedItem.input.headers.orderByColumn === undefined || selectedItem.input.headers.orderByColumn === null)){
                setStatusMessage(statusMessage === "Order By Column is required." ? "Can not proceed with incomplete input data." : "Order By Column is required.")
                setSeverity("warning")
                return validation = false;
            }
            if (selectedItem?.input.headers.hasOwnProperty('orderByDirection') && (selectedItem.input.headers.orderByDirection === undefined || selectedItem.input.headers.orderByDirection === null)){
                setStatusMessage(statusMessage === "Order By Direction is required." ? "Can not proceed with incomplete input data." : "Order By Direction is required.")
                setSeverity("warning")
                return validation = false;
            }
        }

        return validation
    }

    const handleSubmit = (event, input) => {
        event.preventDefault();
        if (!validate()) return

        setStatusMessage(null);
        setSeverity(null)
        setIsLoading(true);

        if ((input.headers !== undefined && Object.keys(input.headers).length > 0) || input.parameters?.length > 0) {
            doRequest(`/api/CustomViewPut/?customViewId=${selectedItem.id}`, idToken, {
                method: "PUT",
                body: JSON.stringify(input)

            })
                .then((response) => {
                    if (!response.isError) {
                        setStatusMessage("Saved.")
                        setSeverity("success")
                        setNewFilter(0);
                        setRefresh(prevState => !prevState);
                        setIsLoading(false)
                    } else {
                        setStatusMessage("An error occurred, please retry.")
                        setSeverity("error")
                        setIsLoading(false);
                    }
                });
        }

        if (Object.keys(deletedInput).length) {
          let objDeletedItems = [];
          deletedInput?.map((parameter) => {
            objDeletedItems.push({"name" : parameter});
          })

            doRequest(`/api/CustomViewParametersDelete/?customViewId=${selectedItem.id}`, idToken, {
                method: "DELETE",
                body: JSON.stringify(objDeletedItems)
            })
                .then((response) => {
                    if (!response.isError) {
                        setStatusMessage("Saved.")
                        setSeverity("success")
                        setNewFilter(0);
                        setRefresh(prevState => !prevState);
                        setIsLoading(false);
                    } else {
                        setStatusMessage("An error occurred, please retry.")
                        setSeverity("error")
                        setIsLoading(false);
                    }
                })
            setDeletedInput([])
        }
    }

    useEffect(() => {
        setSelectedItem(null)
        setDeletedInput([])
        setStatusMessage(null)
        setSeverity(null)
    }, [value])

    useEffect(() => {
        if (selectedItem && statusMessage) {
            handleChange(selectedItem.displayName)
        }
    }, [reRender])

    return (
        <Grid item xs={12} hidden={value !== index} {...other}>
            {value === index && (
                <>
                    <form>
                        <Grid item container xs={12} spacing={2}>
                            <Grid item xs={11}>
                                <Autocomplete
                                    options={options}
                                    renderInput={(params) => <TextField {...params} label="Bespoke View" />}
                                    onChange={(event, newValue) => { handleChange(newValue); }}
                                    loading={loading}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Button variant="contained" size="large" onClick={(event) => handleSubmit(event, selectedItem.input)} sx={{ marginTop: "7px" }}>Save</Button>
                                <Backdrop sx={{ color: '#055A60', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                                    <CircularProgress color="inherit" />
                                </Backdrop>
                            </Grid>
                            <Grid item xs={12}>
                                <RequestStatusAlert message={statusMessage} severity={severity} />
                            </Grid>
                            {selectedItem && (
                                <>
                                    <Grid item container spacing={2}>
                                        <Grid item xs={9}>
                                            <TextField label="Description" size="small" fullWidth name="description" value={selectedItem.description} onChange={(event) => handleHeaderInputChange(event)} />
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField label="Recommended Usage" size="small" fullWidth name="recommendedUsage" value={selectedItem.recommendedUsage} onChange={(event) => handleHeaderInputChange(event)} />
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField label="Data Products Included" size="small" fullWidth name="dataProducts" value={selectedItem.dataProducts} onChange={(event) => handleHeaderInputChange(event)} />
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField label="Requested by" size="small" fullWidth name="requestedBy" value={selectedItem.requestedBy} onChange={(event) => handleHeaderInputChange(event)} />
                                        </Grid>
                                        <Grid
                                            item xs={5}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Switch checked={isBespokeEnabled} onChange={(event) => handleBespokeEnabled(event)} />}
                                                    label="Active"
                                                    name="enabled"
                                                />
                                            </FormGroup>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                select
                                                label="Related Report"
                                                fullWidth
                                                value={selectedItem.reportId || ''}
                                                onChange={handleRelatedReportChange}
                                                name="reportId"
                                            >
                                                <MenuItem value="">None</MenuItem>
                                                {reports.map((report) => (
                                                    <MenuItem key={report.Id} value={report.Id}>
                                                        {report.title} ({report.externalProviderReportId})
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12} style={{ marginBottom: '10px' }}>
                                            <Button variant="contained" onClick={addNewFilter}>Add Filter</Button>
                                            <Button variant="contained" style={{ marginLeft: '10px' }} disabled={disableOrderBtn} onClick={addNewOrder}>Add Order By</Button>
                                        </Grid>
                                        {
                                            (selectedItem?.customViewsParameters.length > 0 || [...Array(newFilter).keys()].length > 0) &&
                                            <Grid item xs={12}>
                                                <Typography variant="h6"><b>Custom Filters</b></Typography>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} sx={{ width: '100%' }}>
                                            {selectedItem?.customViewsParameters?.map((parameter, index) => {
                                                return (
                                                    <FilterParameter key={parameter.id} index={index} parameterName={parameter.name} selectedItem={selectedItem} setSelectedItem={setSelectedItem} deleteFilter={deleteExistingFilter} type={"bespoke"} />
                                                )
                                            })}
                                            {[...Array(newFilter).keys()].map((index) => {
                                                return (
                                                    <NewFilterParameter key={newIds[index]} id={newIds[index]} index={index} selectedItem={selectedItem} setSelectedItem={setSelectedItem} deleteFilter={deleteNewFilter} type={"bespoke"} />
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <form>
                                            {
                                                (selectedItem?.orderByColumn || showOrderPanel) &&
                                                <Grid sx={{ width: '100%' }}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6"><b>Order by</b></Typography>
                                                    </Grid>
                                                    <OrderByFilter selectedItem={selectedItem} setSelectedItem={setSelectedItem} deleteOrderBy={deleteOrderBy} />
                                                </Grid>
                                            }
                                        </form>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </form>
                </>
            )}
        </Grid>
    )
}

function ExternalReportsPanel(props) {
    const { value, index, idToken } = props;
    const [reports, setReports] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);
    const [dataProducts, setDataProducts] = useState([]);

    useEffect(() => {
        if (value === index && idToken) {
            fetchReports();
            fetchDataProducts();
        }
    }, [value, idToken]);

    const fetchReports = async () => {
        setLoading(true);
        const response = await doRequest('/api/ExternalReports', idToken);
        if (!response.isError) {
            setReports(response.data || []);
        }
        setLoading(false);
    };

    const fetchDataProducts = async () => {
        const response = await doRequest('/api/DataProducts', idToken);
        if (!response.isError) {
            setDataProducts(response.data || []);
        }
    };

    const handleReportSelect = (reportId) => {
        console.log('Selected Report ID:', reportId);
        const report = reports.find(r => r.id === reportId);
        setSelectedReport(report);
        setIsNew(false);
        setStatusMessage(null);
    };

    const handleNewReport = () => {
        setSelectedReport({
            reportId: '',
            title: '',
            mainContact: '',
            type: 'PowerBI',
            reportEmbedUrl: '',
            description: '',
            relatedDataProducts: []
        });
        setIsNew(true);
        setStatusMessage(null);
    };

    const handleInputChange = (field, value) => {
        setSelectedReport(prev => ({ ...prev, [field]: value }));
    };

    const handleDataProductChange = (index, field, value) => {
        setSelectedReport(prev => {
            const updated = { ...prev };
            updated.relatedDataProducts[index] = { ...updated.relatedDataProducts[index], [field]: value };
            
            // Auto-populate link when product name is selected
            if (field === 'dataProductIdentifier' && value && (!updated.relatedDataProducts[index].link || updated.relatedDataProducts[index].link === '')) {
                updated.relatedDataProducts[index].link = `/explore/data-products/${value}`;
            }
            
            return updated;
        });
    };

    const addDataProduct = () => {
        setSelectedReport(prev => ({
            ...prev,
            relatedDataProducts: [...(prev.relatedDataProducts || []), { productName: '', link: '' }]
        }));
    };

    const removeDataProduct = (index) => {
        setSelectedReport(prev => ({
            ...prev,
            relatedDataProducts: prev.relatedDataProducts.filter((_, i) => i !== index)
        }));
    };

    const handleSave = async () => {
        setLoading(true);
        setStatusMessage(null);

        const method = isNew ? 'POST' : 'PUT';
        const endpoint = isNew ? '/api/ExternalReports' : `/api/ExternalReports?reportId=${selectedReport.id}`;

        const response = await doRequest(endpoint, idToken, {
            method: method,
            body: JSON.stringify(selectedReport)
        });

        if (!response.isError) {
            setStatusMessage('Saved successfully');
            setSeverity('success');
            await fetchReports();
            if (isNew) {
                setIsNew(false);
            }
        } else {
            setStatusMessage('Error saving report: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this report?')) return;

        setLoading(true);
        const response = await doRequest(`/api/ExternalReports/${selectedReport.id}`, idToken, {
            method: 'DELETE'
        });

        if (!response.isError) {
            setStatusMessage('Deleted successfully');
            setSeverity('success');
            setSelectedReport(null);
            await fetchReports();
        } else {
            setStatusMessage('Error deleting report: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    return (
        <Grid item xs={12} hidden={value !== index}>
            {value === index && (
                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <Autocomplete
                            options={reports.map(r => r.id)}
                            getOptionLabel={(option) => {
                                const report = reports.find(r => r.id === option);
                                return report ? `${report.title} (${report.externalProviderReportId})` : option;
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Report" />}
                            onChange={(event, value) => value && handleReportSelect(value)}
                            loading={loading}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" fullWidth onClick={handleNewReport} sx={{ marginTop: "7px" }}>
                            New Report
                        </Button>
                    </Grid>

                    {statusMessage && (
                        <Grid item xs={12}>
                            <RequestStatusAlert message={statusMessage} severity={severity} />
                        </Grid>
                    )}

                    {selectedReport && (
                        <>
                            <Grid item xs={12}>
                                <Typography variant="h6">Report Details</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="External Provider Report ID"
                                    fullWidth
                                    value={selectedReport.externalProviderReportId}
                                    onChange={(e) => handleInputChange('externalProviderReportId', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Title"
                                    fullWidth
                                    value={selectedReport.title}
                                    required={true}
                                    onChange={(e) => handleInputChange('title', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Main Contact for questions about this report."
                                    fullWidth
                                    value={selectedReport.mainContact}
                                    onChange={(e) => handleInputChange('mainContact', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    label="Type"
                                    fullWidth
                                    value={selectedReport.type}
                                    onChange={(e) => handleInputChange('type', e.target.value)}
                                >
                                    <MenuItem value="PowerBI">PowerBI</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Description"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={selectedReport.description || ''}
                                    onChange={(e) => handleInputChange('description', e.target.value)}
                                    inputProps={{ maxLength: 4000 }}
                                    helperText={`${(selectedReport.description || '').length}/4000 characters`}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Report Embed URL"
                                    fullWidth
                                    value={selectedReport.reportEmbedUrl}
                                    onChange={(e) => handleInputChange('reportEmbedUrl', e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ marginTop: 2 }}>Related Data Products</Typography>
                                <Button variant="outlined" size="small" onClick={addDataProduct} sx={{ marginTop: 1 }}>
                                    Add Data Product
                                </Button>
                            </Grid>

                            {selectedReport.relatedDataProducts?.map((product, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={5}>
                                        <Autocomplete
                                            options={dataProducts.map(dp => dp.dataProductName)}
                                            value={product.dataProductIdentifier || ''}
                                            onChange={(event, newValue) => handleDataProductChange(index, 'dataProductIdentifier', newValue || '')}
                                            renderInput={(params) => <TextField {...params} label="Product Name" size="small" />}
                                            freeSolo
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Link"
                                            fullWidth
                                            size="small"
                                            value={`/explore/data-products/${product.dataProductIdentifier}`}
                                            disabled={true}
                                            onChange={(e) => handleDataProductChange(index, 'link', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Button variant="outlined" color="error" size="small" onClick={() => removeDataProduct(index)}>
                                            Remove
                                        </Button>
                                    </Grid>
                                </React.Fragment>
                            ))}

                            <Grid item xs={12} sx={{ marginTop: 2 }}>
                                <Button variant="contained" onClick={handleSave} disabled={loading} sx={{ marginRight: 2 }}>
                                    Save
                                </Button>
                                {!isNew && (
                                    <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
                                        Delete
                                    </Button>
                                )}
                            </Grid>
                        </>
                    )}

                    <Backdrop sx={{ color: '#055A60', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Grid>
            )}
        </Grid>
    );
}

function ExternalContentPanel(props) {
    const { value, index, idToken } = props;
    const [contents, setContents] = useState([]);
    const [selectedContent, setSelectedContent] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);

    useEffect(() => {
        if (value === index && idToken) {
            fetchContents();
        }
    }, [value, idToken]);

    const fetchContents = async () => {
        setLoading(true);
        const response = await doRequest('/api/ExternalContent', idToken);
        if (!response.isError) {
            setContents(response.data || []);
        }
        setLoading(false);
    };

    const handleContentSelect = (contentId) => {
        const content = contents.find(c => c.id === contentId);
        setSelectedContent(content);
        setIsNew(false);
        setStatusMessage(null);
    };

    const handleNewContent = () => {
        setSelectedContent({
            contentType: 'externalURL',
            contentLink: '',
            displayTitle: '',
            description: '',
            mainContact: '',
            displayMode: 'newTab'
        });
        setIsNew(true);
        setStatusMessage(null);
    };

    const handleInputChange = (field, value) => {
        setSelectedContent(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setLoading(true);
        setStatusMessage(null);

        const method = isNew ? 'POST' : 'PUT';
        const endpoint = isNew ? '/api/ExternalContent' : `/api/ExternalContent?contentId=${selectedContent.id}`;

        const response = await doRequest(endpoint, idToken, {
            method: method,
            body: JSON.stringify(selectedContent)
        });

        if (!response.isError) {
            setStatusMessage('Saved successfully');
            setSeverity('success');
            await fetchContents();
            if (isNew) {
                setIsNew(false);
            }
        } else {
            setStatusMessage('Error saving content: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this content?')) return;

        setLoading(true);
        const response = await doRequest(`/api/ExternalContent/${selectedContent.id}`, idToken, {
            method: 'DELETE'
        });

        if (!response.isError) {
            setStatusMessage('Deleted successfully');
            setSeverity('success');
            setSelectedContent(null);
            await fetchContents();
        } else {
            setStatusMessage('Error deleting content: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    return (
        <Grid item xs={6} hidden={value !== index}>
            {value === index && (
                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <Autocomplete
                            options={contents.map(c => c.id)}
                            getOptionLabel={(option) => {
                                const content = contents.find(c => c.id === option);
                                return content ? `${content.displayTitle}` : option;
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Content" />}
                            onChange={(event, value) => value && handleContentSelect(value)}
                            loading={loading}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" fullWidth onClick={handleNewContent} sx={{ marginTop: "7px" }}>
                            New Content
                        </Button>
                    </Grid>

                    {statusMessage && (
                        <Grid item xs={12}>
                            <RequestStatusAlert message={statusMessage} severity={severity} />
                        </Grid>
                    )}

                    {selectedContent && (
                        <>
                            <Grid item xs={12}>
                                <Typography variant="h6">Content Details</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    label="Content Type"
                                    fullWidth
                                    value={selectedContent.contentType || 'externalURL'}
                                    onChange={(e) => handleInputChange('contentType', e.target.value)}
                                >
                                    <MenuItem value="externalURL">External URL</MenuItem>
                                    <MenuItem value="pdfDocument">PDF Document</MenuItem>
                                    <MenuItem value="">None</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    label="Display Mode"
                                    fullWidth
                                    value={selectedContent.displayMode || 'newTab'}
                                    onChange={(e) => handleInputChange('displayMode', e.target.value)}
                                >
                                    <MenuItem value="popup">Popup</MenuItem>
                                    <MenuItem value="iFrame">iFrame</MenuItem>
                                    <MenuItem value="newTab">New Tab</MenuItem>
                                    <MenuItem value="currentTab">Current Tab</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Display Title"
                                    fullWidth
                                    value={selectedContent.displayTitle || ''}
                                    required={true}
                                    onChange={(e) => handleInputChange('displayTitle', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Content Link"
                                    fullWidth
                                    value={selectedContent.contentLink || ''}
                                    onChange={(e) => handleInputChange('contentLink', e.target.value)}
                                    placeholder="https://example.com/content"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Description"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={selectedContent.description || ''}
                                    onChange={(e) => handleInputChange('description', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Main Contact"
                                    fullWidth
                                    value={selectedContent.mainContact || ''}
                                    onChange={(e) => handleInputChange('mainContact', e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: 2 }}>
                                <Button variant="contained" onClick={handleSave} disabled={loading} sx={{ marginRight: 2 }}>
                                    Save
                                </Button>
                                {!isNew && (
                                    <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
                                        Delete
                                    </Button>
                                )}
                            </Grid>
                        </>
                    )}

                    <Backdrop sx={{ color: '#055A60', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Grid>
            )}
        </Grid>
    );
}

function SnowflakeDataSourcesPanel(props) {
    const { value, index, idToken } = props;
    const [dataSources, setDataSources] = useState([]);
    const [selectedDataSource, setSelectedDataSource] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [severity, setSeverity] = useState(null);

    useEffect(() => {
        if (value === index && idToken) {
            fetchDataSources();
        }
    }, [value, idToken]);

    const fetchDataSources = async () => {
        setLoading(true);
        const response = await doRequest('/api/SnowflakeDataSources', idToken);
        if (!response.isError) {
            setDataSources(response.data || []);
        }
        setLoading(false);
    };

    const handleDataSourceSelect = (dataSourceId) => {
        const ds = dataSources.find(d => d.id === dataSourceId);
        setSelectedDataSource(ds);
        setIsNew(false);
        setStatusMessage(null);
    };

    const handleNewDataSource = () => {
        setSelectedDataSource({
            warehouse: '',
            database: '',
            schema: '',
            allowedRolesCsv: ''
        });
        setIsNew(true);
        setStatusMessage(null);
    };

    const handleInputChange = (field, value) => {
        setSelectedDataSource(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setLoading(true);
        setStatusMessage(null);

        const method = isNew ? 'POST' : 'PUT';
        const endpoint = isNew ? '/api/SnowflakeDataSources' : `/api/SnowflakeDataSources?dataSourceId=${selectedDataSource.id}`;

        const response = await doRequest(endpoint, idToken, {
            method: method,
            body: JSON.stringify(selectedDataSource)
        });

        if (!response.isError) {
            setStatusMessage('Saved successfully');
            setSeverity('success');
            await fetchDataSources();
            if (isNew) {
                setIsNew(false);
            }
        } else {
            setStatusMessage('Error saving data source: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this Snowflake data source?')) return;

        setLoading(true);
        const response = await doRequest(`/api/SnowflakeDataSources/${selectedDataSource.id}`, idToken, {
            method: 'DELETE'
        });

        if (!response.isError) {
            setStatusMessage('Deleted successfully');
            setSeverity('success');
            setSelectedDataSource(null);
            await fetchDataSources();
        } else {
            setStatusMessage('Error deleting data source: ' + response.data);
            setSeverity('error');
        }
        setLoading(false);
    };

    return (
        <Grid item xs={12} hidden={value !== index}>
            {value === index && (
                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <Autocomplete
                            options={dataSources.map(d => d.id)}
                            getOptionLabel={(option) => {
                                const ds = dataSources.find(d => d.id === option);
                                return ds ? `${ds.database}.${ds.schema} (${ds.warehouse})` : option;
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Snowflake Data Source" />}
                            onChange={(event, value) => value && handleDataSourceSelect(value)}
                            loading={loading}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" fullWidth onClick={handleNewDataSource} sx={{ marginTop: "7px" }}>
                            New Data Source
                        </Button>
                    </Grid>

                    {statusMessage && (
                        <Grid item xs={12}>
                            <RequestStatusAlert message={statusMessage} severity={severity} />
                        </Grid>
                    )}

                    {selectedDataSource && (
                        <>
                            <Grid item xs={12}>
                                <Typography variant="h6">Snowflake Data Source Details</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Warehouse"
                                    fullWidth
                                    required
                                    value={selectedDataSource.warehouse}
                                    onChange={(e) => handleInputChange('warehouse', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Database"
                                    fullWidth
                                    required
                                    value={selectedDataSource.database}
                                    onChange={(e) => handleInputChange('database', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Schema"
                                    fullWidth
                                    required
                                    value={selectedDataSource.schema}
                                    onChange={(e) => handleInputChange('schema', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Allowed Roles (comma-separated)"
                                    fullWidth
                                    value={selectedDataSource.allowedRolesCsv || ''}
                                    onChange={(e) => handleInputChange('allowedRolesCsv', e.target.value)}
                                    helperText="e.g. Admin,Support,DataEngineer"
                                />
                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: 2 }}>
                                <Button variant="contained" onClick={handleSave} disabled={loading} sx={{ marginRight: 2 }}>
                                    Save
                                </Button>
                                {!isNew && (
                                    <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
                                        Delete
                                    </Button>
                                )}
                            </Grid>
                        </>
                    )}

                    <Backdrop sx={{ color: '#055A60', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </Grid>
            )}
        </Grid>
    );
}

const AdminPage = ({ idToken, drawerWidth }) => {
    const [tab, setTab] = useState(0);
    const [dataProducts, setDataProducts] = useState([]);
    const [bespokeViews, setBespokeViews] = useState([]);
    const [refreshDataProducts, setRefreshDataProducts] = useState(false);
    const [refreshBespokeViews, setRefreshBespokeViews] = useState(false);
    const [reRenderDataProducts, setReRenderDataProducts] = useState(false);
    const [reRenderBespokeViews, setReRenderBespokeViews] = useState(false);

    const handleChange = (event, newValue) => {
        setTab(newValue);
    }

    useEffect(() => {
        doRequest('/api/DataProducts', idToken)
            .then((response) => {
                setDataProducts(response.data)
                setReRenderDataProducts(prevState => !prevState)
            })
    }, [refreshDataProducts])

    useEffect(() => {
        doRequest('/api/CustomViews', idToken)
            .then((response) => {
                setBespokeViews(response.data)
                setReRenderBespokeViews(prevState => !prevState)
            })
    }, [refreshBespokeViews])
    
    const generateKey = () => {
        return JSON.stringify(uuidv4())
    }

    return (
        <Grid container spacing={2} style={{ width: 'auto', marginTop: "2px", marginLeft: drawerWidth - 15 }}>
            <Grid item xs={12} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChange}>
                    <Tab label="Data Products" />
                    <Tab label="Bespoke Views" />
                    <Tab label="External Reports" />
                    <Tab label="External Content" />
                    <Tab label="Snowflake Data Sources" />
                </Tabs>
            </Grid>
            <Grid container item xs={12}>
                <DataProductPanel value={tab} index={0} idToken={idToken} dataProducts={dataProducts} reRender={reRenderDataProducts} setRefresh={setRefreshDataProducts} generateKey={generateKey}>
                    Data products
                </DataProductPanel>
                <BespokeViewPanel value={tab} index={1} idToken={idToken} bespokeViews={bespokeViews} reRender={reRenderBespokeViews} setRefresh={setRefreshBespokeViews} generateKey={generateKey}>
                    Bespoke views
                </BespokeViewPanel>
                <ExternalReportsPanel value={tab} index={2} idToken={idToken} generateKey={generateKey}>
                    External Reports
                </ExternalReportsPanel>
                <ExternalContentPanel value={tab} index={3} idToken={idToken} generateKey={generateKey}>
                    External Content
                </ExternalContentPanel>
                <SnowflakeDataSourcesPanel value={tab} index={4} idToken={idToken} generateKey={generateKey}>
                    Snowflake Data Sources
                </SnowflakeDataSourcesPanel>
            </Grid>
        </Grid>
    )
}

export default React.memo(AdminPage)